import type { Infer } from 'superstruct';
import { boolean, number, object, optional, string } from 'superstruct';

import {
	emptyStringIsNull,
	withMessage,
} from '@adflow/shared/util-superstruct';

import { MediaKindDto } from './media-types.dto';

export const AddMediaDto = object({
	kind: MediaKindDto,
	name: withMessage(emptyStringIsNull(string()), 'validations:Required'),
	contentType: emptyStringIsNull(string()),
	logo: optional(boolean()),
	adAccountId: optional(number()),
});
export type AddMediaDto = Infer<typeof AddMediaDto>;
